// extracted by mini-css-extract-plugin
export var LeftContainer = "Banner-module--LeftContainer--0e678";
export var RightContainer = "Banner-module--RightContainer--d00fa";
export var SectionBanner = "Banner-module--SectionBanner--23a16";
export var TextContainer = "Banner-module--TextContainer--19f7d";